import { jsx as _jsx } from "react/jsx-runtime";
import { Navigate, Outlet } from "react-router-dom";
import { useContext } from "react";
import { AuthContext } from "../AuthContext";
const GuestOnlyRoute = () => {
    const { isAuthenticated, isLoading, userId } = useContext(AuthContext);
    if (isLoading) {
        return null; // или глобальный лоадер
    }
    if (isAuthenticated) {
        return _jsx(Navigate, { to: userId ? `/userlk/${userId}` : "/userlk", replace: true });
    }
    return _jsx(Outlet, {});
};
export default GuestOnlyRoute;
